/**
 * @generated SignedSource<<78c330712e82fe627f079daee4c97a6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddRegionDialog_country$data = {
  readonly id: string;
  readonly " $fragmentType": "AddRegionDialog_country";
};
export type AddRegionDialog_country$key = {
  readonly " $data"?: AddRegionDialog_country$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddRegionDialog_country">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddRegionDialog_country",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Country",
  "abstractKey": null
};

(node as any).hash = "d2544c57937e186d69c0dfaef9605e26";

export default node;
